import * as React from 'react'

import { Section, Title } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

type TitleProps = React.ComponentProps<typeof Title>

interface Props {
  paramsProcessor: Record<string, any>
  canCreateCustomField: boolean
  toggleModal: () => void
  descriptionLink?: TitleProps['link']
  children: React.ReactNode
}

const CustomFieldsHeader = ({
  paramsProcessor,
  toggleModal,
  canCreateCustomField,
  descriptionLink,
  children,
}: Props) => {
  return (
    <Section.List
      illustration={paramsProcessor.get('illustration')}
      title={paramsProcessor.get('title')}
      description={paramsProcessor.get('description')}
      link={descriptionLink}
      action={
        canCreateCustomField
          ? {
              onClick: toggleModal,
              label: paramsProcessor.get('addQuestionLabel'),
            }
          : undefined
      }
    >
      {children}
    </Section.List>
  )
}

export default observer(CustomFieldsHeader)
